import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import SearchBar from "../../components/universal/SearchBar";
import SermonPlanForm from "../Plan/SermonPlanForm";
import Navbar from "../../components/universal/Navbar";

function AddSermonPlans() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // ✅ Check if the current path includes "addfield"
  const hideUI = location.pathname.includes("addfield")||location.pathname.includes("addMinistryField")||location.pathname.includes("addChannelField");

  const { church, _id } = location.state || {};

  return (
    <div className="App relative bg-[#191919] h-fit min-h-screen flex p-4">
      {/* ✅ Conditionally render Navbar */}
      {!hideUI && <Navbar />}

      <div className="flex-1 md:pl-32 md:pt-0 pt-20">
        <div className="flex flex-col gap-4 h-full">
          {/* ✅ Conditionally render SearchBar */}
          {!hideUI && (
            <SearchBar
              placeholder={"Search"}
              //value={value}
              //onChangeSearchBar={onChangeSearchBar}
            />
          )}

          <div className="MAIN-CONTENT flex-1 flex flex-col h-full gap-4">
            <div className="flex justify-end">
              <Link to={"/sermon-plans/all"}>
                <button className=" text-[13px] text-greyish border px-4 py-2 border-greyish bg-blackish rounded-xl">
                  See All Sermon Plans
                </button>
              </Link>
            </div>

            <SermonPlanForm church={church} typeofentity="church" planId={_id} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddSermonPlans;
